import {defaultActionCreator} from "./actionCreator";

export const GET_CREDENTIAL_REQUEST = 'GET_CREDENTIAL_REQUEST'
export const getCredentialRequest = defaultActionCreator(GET_CREDENTIAL_REQUEST, 'data')
export const GET_CREDENTIAL_SUCCESS = 'GET_CREDENTIAL_SUCCESS'
export const getCredentialSuccess = defaultActionCreator(GET_CREDENTIAL_SUCCESS, 'data')
export const GET_CREDENTIAL_ERROR = 'GET_CREDENTIAL_ERROR'
export const getCredentialError = defaultActionCreator(GET_CREDENTIAL_ERROR, 'data')
